
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: "",
props: [""],
data() {
return {
showContent001: false,
showContent004: false,
showContent003: false,
showContent002: false
};
},

components: { Group, Cell, CellFormPreview, CellBox },

created() {},

beforeMount() {},

mounted() {},
methods: {},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/help.vue